// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Togo */
const TG = /^(?:(?:7[0-289]|9[0-36-9])\d{6})$/;

export default TG;
